<template>
  <div
    :style="{
      backgroundColor: bgColor,
      border: trend == 'up' ? ' 1px solid rgba(5,147,71,.2)' : '1px solid rgba(202,42,29,.2)',
    }"
    style=" border-radius: 5px;padding: 16px; text-align: center;"
  >
    <table width="100%" style="border-collapse: collapse;">
      <tr>
        <td style="padding-right: 10px;">
          <img
            src="https://gatoreviews.s3.eu-west-3.amazonaws.com/common/emails/new/thumb-up.png"
            width="24"
            v-if="trend === 'up'"
            style="margin-top:-7px;"
          />
          <img
            src="https://gatoreviews.s3.eu-west-3.amazonaws.com/common/emails/new/thumb-down.png"
            width="24"
            v-else-if="trend === 'down'"
            style="margin-top:-7px;"
          />
        </td>
        <td style=" color: #059347; font-size: 14px; font-weight: bold;">
          <template v-if="trend === 'up'">
            {{ $t('report.globalTrendUp') }}
          </template>
          <template v-else-if="trend === 'down'">
            {{ $t('report.globalTrendDown') }}
          </template>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: 'LayoutBlockFooter',
  props: {
    trend: {
      type: String,
      default: '',
    },
  },
  computed: {
    bgColor() {
      if (this.trend === 'up') {
        return 'rgba(5,147,71,.1)'
      } else if (this.trend === 'down') {
        return 'rgba(202,42,29,.1)'
      }
      return ''
    },
  },
}
</script>
